// 연주자
import pollini from '../images/mauriziopollini.avif';
import godowsky from '../images/leopoldgodowsky.jpg';
import cortot from '../images/alfredcortot.jpg';
import samson_francois from '../images/samsonfrancois.jpg';
import rubinstein from '../images/arthurrubinstein.jpg';
import horowitz from '../images/vladimirhorowitz.jpg';
import cliburn from '../images/vancliburn.jpg';
import richter from '../images/sviatoslavrichter.webp';
import ashkenazy from '../images/vladimirashkenazy.jpg';
import argerich from '../images/marthaargerich.jpg';
import zimerman from '../images/krystianzimerman.jpg';
import kissin from '../images/yevgenykissin.jpg';
import yuja_wang from '../images/yujawang.webp';
import lang_lang from '../images/langlang.avif';
import trifonov from '../images/daniiltrifonov.jpg';
import sherman from '../images/russellsherman.jpeg';
import perlman from '../images/itzhakperlman.jpg';
import heifetz from '../images/jaschaheifetz.jpeg';
import du_pre from '../images/jacquelinedupre.jpeg';
import rostropovich from '../images/mstislavrostropovich.avif';

// 지휘자
import abbado from '../images/claudioabbado.avif';
import bohm from '../images/karlbohm.webp';
import karajan from '../images/herbertvonkarajan.jpg';
import bernstein from '../images/leonardbernstein.jpg';
import barenboim from '../images/danielbarenboim.jpg';
import dudamel from '../images/gustavodudamel.jpg';
import makkela from '../images/klausmakkela.webp';
import shaham from '../images/rikhavshaham.jpg';
import altinoglu from '../images/alainaltinogluu.jpeg';

// 한국 음악가
import donghyek_lim from '../images/donghyeklim.jpg';
import dongmin_lim from '../images/dongminlim.jpeg';
import byungdong_paik from '../images/backbuyngdong.jpeg';
import kyungwha_chung from '../images/kyungwhachung.webp';
import myungwhun_chung from '../images/myungwhunchung.jpg';
import kunwoo_paik from '../images/kunwoopaik.jpg';
import isang_yun from '../images/isangyun.jpeg';
import hanna_chang from '../images/hannachang.webp';
import yeoleum_son from '../images/yeoleumson.jpeg';
import sunuk_kim from '../images/sunwookim.jpg';
import yekwon_sunwoo from '../images/yekwonsunwoo.jpg';
import unsuk_chin from '../images/unsukchin.avif';
import seongjin_cho from '../images/seongjincho.jpg';
import yunchan_lim from '../images/yunchanlim.jpg';
import inmo_yang from '../images/inmoyang.jpeg';
import bomsoree_kim from '../images/bomsorikim.jpg';
import taeguk_moon from '../images/taegukmoon.webp';
import minsu_son from '../images/minsuson.jpg';
import jaemin_han from '../images/jaeminhan.jpg';
import sehyun_kim from '../images/sehyunkim.webp';
import songhyun_kim from '../images/songhyunkim.webp';
import clara_jumi_kang from '../images/clarajumikang.jpeg';
import sujung_shin from '../images/sujungshin.jpg';
import eha_nuri from '../images/ehanuri.webp';

export const peopleImages = {
  // 연주자
  pollini,
  godowsky,
  cortot,
  samson_francois,
  rubinstein,
  horowitz,
  cliburn,
  richter,
  ashkenazy,
  argerich,
  zimerman,
  kissin,
  yuja_wang,
  lang_lang,
  trifonov,
  sherman,
  perlman,
  heifetz,
  du_pre,
  rostropovich,
  // 지휘자
  abbado,
  bohm,
  karajan,
  bernstein,
  barenboim,
  dudamel,
  makkela,
  shaham,
  altinoglu,
  // 한국 음악가
  donghyek_lim,
  dongmin_lim,
  byungdong_paik,
  kyungwha_chung,
  myungwhun_chung,
  kunwoo_paik,
  isang_yun,
  hanna_chang,
  yeoleum_son,
  sunuk_kim,
  yekwon_sunwoo,
  unsuk_chin,
  seongjin_cho,
  yunchan_lim,
  inmo_yang,
  bomsoree_kim,
  taeguk_moon,
  minsu_son,
  jaemin_han,
  sehyun_kim,
  songhyun_kim,
  clara_jumi_kang,
  sujung_shin,
  eha_nuri,
};
